import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ContractsDirectKpiCfg, ContractsDirectKpiCfgService } from "./contractsDirectKpiCfg.service";
import { ContractsDirectKpiService, Range } from "./contractsDirectKpiService";
import { DateRange } from "./dateRange";

export class ContractDetail {
    public unitId: string;
    public unitName: string;
    public userDocNumber: string;
    public userName: string;
    public beginDate: Date;
    public endDate: Date;
    public workContractId: string;
    public workerId: number;
    public workerName: string;
    public workerEmail: string;
    public workerPhone: string;
    public clientFiscalName: string;
    public clientPhone: string;
    public contactName: string;
    public contactPhone: string;
}

export class ExpiringContractsDirectDetailServiceData {
    public contracts: ContractDetail[];
    public updateTimestamp: Date;
    
}

export abstract class ExpiringContractsDirectDetailService extends ContractsDirectKpiService<ExpiringContractsDirectDetailServiceData> {
    protected abstract getRange(): DateRange;
    constructor(private serviceCfg: ContractsDirectKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(DateRange.Inmediate);
    }

    protected async update(): Promise<ExpiringContractsDirectDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: ExpiringContractsDirectDetailServiceData = null;
            try {
                let cfg: ContractsDirectKpiCfg = this.serviceCfg.getCfg();
                
                let { begin, end } = this.getDateRange(this.getRange());
                let url = cfg.expiringContractsDirect.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<ExpiringContractsDirectDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastExpiringContractsDirectDetailService extends ExpiringContractsDirectDetailService {
    public getClassName() { return "PastExpiringContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Past; }
}

@Injectable()
export class InmediateExpiringContractsDirectDetailService extends ExpiringContractsDirectDetailService {
    public getClassName() { return "InmediateExpiringContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Inmediate; }
}

@Injectable()
export class ForecastedExpiringContractsDirectDetailService extends ExpiringContractsDirectDetailService {
    public getClassName() { return "ForecastedExpiringContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Forecast; }
}